import {SC_ServiceFileType} from "../../util/api/enums/SC_ServiceFileType";
import {SC_ServiceFile} from "../../util/api/files/SC_ServiceFile";
import {SC_WorkorderObject} from "../../util/api/SC_WorkorderObject";

export class FontAwesomeButtonEnumTypes {
    static readonly DISABLED = 0;
    static readonly ENABLED = 1;

    static readonly MAINS_COLOR_NONE = 0;
    static readonly MAINS_COLOR_RED = 1;
    static readonly MAINS_COLOR_ORANGE = 2;
    static readonly MAINS_COLOR_YELLOW = 3;
    static readonly MAINS_COLOR_YELLOW_GREEN = 4;
    static readonly MAINS_COLOR_GREEN = 5;
    static readonly MAINS_COLOR_BLUE = 6;
    static readonly MAINS_COLOR_DEEP_BLUE = 7;

    static readonly BORDER_COLOR_BLACK = 0;
    static readonly BORDER_COLOR_RED = 1;
    static readonly BORDER_COLOR_ORANGE = 2;
    static readonly BORDER_COLOR_YELLOW = 3;
    static readonly BORDER_COLOR_YELLOW_GREEN = 4;
    static readonly BORDER_COLOR_GREEN = 5;
    static readonly BORDER_COLOR_BLUE = 6;

    static readonly ANIMATION_NONE = 0;
    static readonly ANIMATION_WAVE_FLAG = 1;
    static readonly ANIMATION_RING_BELL = 2;

    readonly enabled: number;
    readonly mainColor: number | string;
    readonly borderColor: number;
    readonly animation: number;

    constructor({
                    enabled = FontAwesomeButtonEnumTypes.ENABLED,
                    mainColor = FontAwesomeButtonEnumTypes.MAINS_COLOR_NONE,
                    borderColor = FontAwesomeButtonEnumTypes.BORDER_COLOR_BLACK,
                    animation = FontAwesomeButtonEnumTypes.ANIMATION_NONE,
                } = {}) {
        this.enabled = enabled;
        this.mainColor = mainColor;
        this.borderColor = borderColor;
        this.animation = animation;
    }

    /**
     * @returns {string}
     */
    get getMainColor(): string {
        if (typeof this.mainColor === "string")
            return this.mainColor;

        switch (this.mainColor) {
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_RED:
                return "fa-button-red";
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_ORANGE:
                return "fa-button-orange";
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_YELLOW:
                return "fa-button-yellow";
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_YELLOW_GREEN:
                return "fa-button-yellow-green";
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_GREEN:
                return "fa-button-green";
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_BLUE:
                return "fa-button-blue";
            case FontAwesomeButtonEnumTypes.MAINS_COLOR_DEEP_BLUE:
                return "fa-button-dark-blue";
        }

        return "fa-button-none";
    }

    /**
     * @returns {string}
     */
    get getBorderColor(): string {
        switch (this.borderColor) {
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_BLACK:
                return "fa-button-border-black";
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_RED:
                return "fa-button-border-red";
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_ORANGE:
                return "fa-button-border-orange";
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_YELLOW:
                return "fa-button-border-yellow";
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_YELLOW_GREEN:
                return "fa-button-border-yellow-green";
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_GREEN:
                return "fa-button-border-green";
            case FontAwesomeButtonEnumTypes.BORDER_COLOR_BLUE:
                return "fa-button-border-blue";
        }

        return "";
    }

    /**
     * @returns {string}
     */
    get getAnimationClass(): string {
        switch (this.animation) {
            case FontAwesomeButtonEnumTypes.ANIMATION_WAVE_FLAG:
                return "fa-button-animate-wave";
            case FontAwesomeButtonEnumTypes.ANIMATION_RING_BELL:
                return "fa-button-animate-ring";
        }

        return "";
    }
}
